// Bundle base, cargado en todas las páginas.
// Las dependencias pesadas (Quill, Chart.js) viven en los bundles "editor" y
// "charts", que solo se incluyen en las páginas que las necesitan.
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "./controllers"

ActiveStorage.start()
